import { ComponentChild, h } from 'preact'

type OnChange = (newValue: string) => void
type OnEnter = () => void

const handleEnter = (e: KeyboardEvent, onEnter: OnEnter | undefined) => {
  if (e.key === 'Enter' && onEnter) {
    e.preventDefault()
    e.stopPropagation()
    onEnter()
  }
}

const handleChange = (e: KeyboardEvent, onChange: OnChange) => {
  if (e.target instanceof HTMLInputElement && onChange) {
    onChange(e.target.value)
  }
}

interface Props {
  attributes: {
    type?: string,
    placeholder?: string,
    value?: string
  },
  className?: string,
  preIcon?: ComponentChild,
  postIcon?: ComponentChild,
  onEnter?: OnEnter,
  onChange: OnChange
}

const InputGroup = (props: Props) => {
  return <div className='form-group'>
    <div className='input-wrapper'>
      { props.preIcon ? (
        <span className='pre-icon-wrapper input-icon-wrapper'>
          { props.preIcon }
        </span>
      ) : null }
      <input
        className={`input-group ${props.className} ${props.postIcon ? 'has-post-icon' : ''}`}
        onKeyUp={(e: KeyboardEvent) => handleChange(e, props.onChange)}
        onKeyDown={(e: KeyboardEvent) => handleEnter(e, props.onEnter)}
        {...props.attributes}
      />
      { props.postIcon ? (
        <span className='post-icon-wrapper input-icon-wrapper'>
          { props.postIcon }
        </span>
      ) : null }
    </div>
  </div>
}

export default InputGroup
